import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogActions } from '../../../components/material-ui/Dialog';
import { DialogControls } from '../../../components/DialogControls/DialogControls';

export const SettingActions = memo(({ onSave, onClose }) => {
    const { t: translate } = useTranslation();

    const actionList = React.useMemo(
        () => [
            {
                label: translate('cancel').toUpperCase(),
                primary: false,
                onClick: onClose,
            },
            {
                label: translate('ok'),
                primary: true,
                onClick: onSave,
            },
        ],
        [onSave, translate]
    );

    return (
        <DialogActions>
            <DialogControls actions={actionList} />
        </DialogActions>
    );
});
